import { FieldDefinition, FormModelDefinition } from './definitions';

export const fieldDefinitions: FieldDefinition[] = [];
export const formModelDefinitions: FormModelDefinition[] = [];
